import { render, staticRenderFns } from "./WeitereZieleBase.vue?vue&type=template&id=b1435d72"
import script from "./WeitereZieleBase.vue?vue&type=script&lang=js"
export * from "./WeitereZieleBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports